module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="form_wrapper">\n	<h3 id="form_header">\n		' +
((__t = ( I18n.t('uploader.form.instructions') )) == null ? '' : __t) +
'\n	</h3>\n	<div id="name_input">\n		<input id="fullname_input_text" type="text"\n			placeholder="' +
((__t = ( isDefaultNamePlaceholder() ? I18n.t('uploader.form.placeholders.fullname') : getNamePlaceholder() )) == null ? '' : __t) +
'"\n			' +
((__t = ( disableFields() ? 'disabled' : '' )) == null ? '' : __t) +
' />\n		<label for="fullname_input_text">' +
((__t = ( I18n.t('uploader.form.name') )) == null ? '' : __t) +
'</label>\n		<div class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n	</div>\n	<div id="email_input">\n		<input id="email_input_text" type="email"\n			placeholder="' +
((__t = ( isDefaultEmailPlaceholder() ? I18n.t('uploader.form.placeholders.email') : getEmailPlaceholder() )) == null ? '' : __t) +
'"\n			' +
((__t = ( disableFields() ? 'disabled' : '' )) == null ? '' : __t) +
' />\n		<label for="email_input_text">' +
((__t = ( I18n.t('uploader.form.email') )) == null ? '' : __t) +
'</label>\n		<div class="validate">' +
((__t = ( I18n.t('uploader.form.validate.email') )) == null ? '' : __t) +
'</div>\n		<div class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n	</div>\n	<div id="dob_input">\n		<input id="dob_input_text" type="date" placeholder="YEAR-MM-DD"  min="1920-01-01" max="2017-01-01" />\n		<label for="dob_input_text">' +
((__t = ( I18n.t('uploader.form.dob') )) == null ? '' : __t) +
'</label>\n		<div tabindex="0" class="validate" style="display:none;">' +
((__t = ( I18n.t('uploader.form.validate.dob') )) == null ? '' : __t) +
'</div>\n		<div tabindex="0" class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n	</div>\n	' +
((__t = (  getExtraFields() )) == null ? '' : __t) +
'\n	<div id="client_tos_holder" class="tos_input">\n		<div class="tos_input_link_wrapper"> <!-- Not using <label> here since we don\'t want to highlight the checkbox when hovering the link-->\n			<input id="client_tos_checkbox" type="checkbox" aria-label="' +
((__t = (getBrandTOSLinkText() )) == null ? '' : __t) +
'" />\n			<a title=\'' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'\' href="' +
((__t = (getBrandTOSLinkUrl())) == null ? '' : __t) +
'" target=\'_blank\'>' +
((__t = (
				getBrandTOSLinkText() )) == null ? '' : __t) +
'</a>\n		</div>\n		<div class="error">' +
((__t = ( I18n.t('uploader.form.validate.required') )) == null ? '' : __t) +
'</div>\n	</div>\n	' +
((__t = (  getExtraTosFields() )) == null ? '' : __t) +
'\n</div>\n<button id="submit_content_button" class="bottom_button">\n	' +
((__t = ( I18n.t('uploader.buttons.submit') )) == null ? '' : __t) +
'\n</button>\n';

}
return __p
}